// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1D94F","list":"BalanceDue_list__1BCZ-","listRow":"BalanceDue_listRow__10OA6","total":"BalanceDue_total__gkIJD"};